import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { questionsListActions } from '../../../core/questions-list';
import { ModalReportTT } from '../../../views/pages/home/thinkingTalents/ModalReportTT';
import { QuadrantList } from '../../../views/components/community/QuadrantList';
import { QuadrantListCollapsed } from '../../../views/components/community/QuadrantListCollapsed';

export const ReportTT = ({ questions_list, user_finded, collapsed = false, showAllItems = false }) => {
    const dispatch = useDispatch()
    const questions = useSelector(state => state.questions)

    useEffect(() => {
        if (questions && !questions.isPending && !questions.id) dispatch(questionsListActions.loadQuestions())
    }, [dispatch, questions])

    questions_list = useSelector(state => state.questions)

    const [modal, setModal] = useState(false);
    const [current_item, setCurrentItem] = useState(null);

    const user = useSelector(state => state.user );

    const [lengthItems, setLengthItems] = useState({
        Analytic: 0,
        Innovative: 0,
        Procedural: 0,
        Relational: 0,
        All: 0
    })

    useEffect(() => {
        if (!user_finded) {
            user.talents && user.talents.forEach(quadrant => {
                setValue(quadrant.quadrant, quadrant.items.length)
            })
        }
    }, [user.talents])

    useEffect(() => {
        if (user_finded) {
            user_finded.talents && user_finded.talents.forEach(quadrant => {
                if (quadrant.quadrant && quadrant.items?.length) {
                    setValue(quadrant.quadrant, quadrant.items?.length)
                }
            })
        }
    }, [user_finded])

    const setValue = (name, value) => {
        setLengthItems({
            ...lengthItems,
            [name]: value
        })
    }

    const toggle = (key) => {
        setModal(!modal)
        setCurrentItem(questions_list.quadrants.find(item => item.name === key))
    }

    return (
        <>
            <div className="graphic-map graphic-map-sm mx-auto" style={{ minHeight: `${collapsed ? '84px' : ''}` }}>
                <div className="graphic-map-list overflow-hidden mx-auto">
                    {collapsed && <QuadrantListCollapsed user={user_finded} />}
                    {!collapsed && <QuadrantList user={user_finded} toggle={toggle} />}
                </div>
            </div>
            {!collapsed &&
                <div className='d-flex mx-auto align-items-center justify-content-center'>
                    <p className="mb-0 mr-3">
                        <i className="icon mr-2">
                            <svg width="16" height="16" className="mt-n1 text-always">
                                <circle cx="8" cy="8" r="8" fill="currentColor" />
                            </svg>
                        </i><span className='small'>Always</span>
                    </p>
                    <p className="mb-0 mr-3">
                        <i className="icon mr-2">
                            <svg width="16" height="16" className="mt-n1 border-primary border rounded">
                                <circle cx="8" cy="8" r="8" fill="#ffffff" />
                            </svg>
                        </i><span className='small'>Sometimes</span>
                    </p>
                    <p className="mb-0 mr-3">
                        <i className="icon mr-2">
                            <svg width="16" height="16" className="mt-n1 text-never">
                                <circle cx="8" cy="8" r="8" fill="currentColor" />
                            </svg>
                        </i><span className='small'>Never</span>
                    </p>
                </div>
            }


            {!collapsed &&
                <ModalReportTT
                    showAllItems={showAllItems}
                    modal={modal}
                    toggle={toggle}
                    current_item={current_item}
                    user={user_finded ? user_finded : user}
                />}

        </>
    )
}

export default ReportTT